/* RECUERDOS · Experiencias (2026-10-22, pedido del usuario).
   Los tours son fotos impresas que, con el scroll, suben y caen una sobre
   otra; las de abajo se achican, se apagan y toman un tono de foto antigua.
   La escena es una caja verde vista desde arriba: las fotos caen dentro
   (llegan desde arriba, más grandes y levantadas, y se asientan) y al final
   la franja verde con «Organizamos tu día» cae encima de todo (2026-10-23).
   La caja entra con el scroll (--rec-fondo en la sección). Después la
   escena se suelta y sigue el pie.
   La escena es sticky de CSS (.rec-escena dentro de .rec-pista, ver
   «RECUERDOS» en site.css); aquí sólo se lee el avance de la pista y se
   escribe transform / opacity / filter y variables en los elementos de la
   escena. Nada en :root, sin pins. Con movimiento reducido no se activa:
   queda la pila de siempre y la franja debajo. */
(function () {
  'use strict';
  var sec = document.querySelector('.itin--recuerdos');
  if (!sec) return;
  var pista = sec.querySelector('.rec-pista'), escena = sec.querySelector('.rec-escena');
  var franja = sec.querySelector('.itin-end'), indice = sec.querySelector('.rec-indice');
  var indiceActual = indice && indice.querySelector('.rec-indice-actual');
  var cards = Array.prototype.slice.call(sec.querySelectorAll('.itin-card'));
  var n = cards.length;
  if (!pista || !escena || n < 2) return;
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Giro y desvío propios de cada foto: el montón se ve dejado a mano.
  var GIRO = [-2.2, 1.6, -1.1, 2.3, -1.7, 1.2, -0.6];
  var DESVIO = [-26, 30, -16, 22, -30, 16, 0];
  // Tramos de scroll (en --rec-tramo): una llegada por foto después de la
  // primera, uno para ordenar el montón y cruzar la franja, y una pausa
  // para leerla antes de que la escena se suelte.
  var LARGO = (n - 1) + 1.1 + 0.7;
  var piezas = cards.map(function (li, i) {
    li.style.zIndex = String(i + 1);
    return { li: li, card: li.querySelector('.itin-card-in'), texto: li.querySelector('.itin-card-text'), t: '', o: '', f: '', a: '', op: '', fondo: null };
  });

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function suave(x) { return x * x * (3 - 2 * x); }

  var activo = false, pendiente = 0, alto = 0, topFijo = 0, recorrido = 1, movil = false;
  var cache = {};

  var cabeza = sec.querySelector('.itin-head');
  function medir() {
    // El encabezado va clavado con la caja: su alto la achica.
    if (cabeza) sec.style.setProperty('--rec-cabeza', cabeza.offsetHeight + 'px');
    alto = escena.offsetHeight;
    topFijo = parseFloat(getComputedStyle(escena).top) || 0;
    recorrido = Math.max(1, pista.offsetHeight - alto);
    movil = innerWidth <= 900;
  }
  function poner(clave, valor, fn) { if (cache[clave] !== valor) { cache[clave] = valor; fn(valor); } }
  function variable(el, nombre, valor) { poner(nombre, valor, function (v) { el.style.setProperty(nombre, v); }); }

  function pintar() {
    pendiente = 0;
    if (!activo) return;
    var r = pista.getBoundingClientRect();
    var u = clamp((topFijo - r.top) / recorrido, 0, 1) * LARGO;
    var b = suave(clamp(u - (n - 1), 0, 1));             // el montón se ordena
    // La caja (y el verde del encabezado) entra mientras la escena sube a su sitio.
    var fondo = clamp((topFijo - r.top + alto * 0.9) / (alto * 0.9), 0, 1);
    variable(sec, '--rec-fondo', fondo.toFixed(3));

    piezas.forEach(function (p, i) {
      var e = i === 0 ? 1 : clamp(u - (i - 1), 0, 1);
      var cae = 1 - e * e;                                // 1 en lo alto, 0 al tocar fondo (acelera)
      var d = clamp(u - i, 0, n - 1 - i);                 // fotos que tiene encima
      var dd = Math.min(d, 4);
      var giro = GIRO[i % GIRO.length], desv = DESVIO[i % DESVIO.length] * (movil ? 0.5 : 1);
      // Caída: llega desde arriba (más grande, levantada, con más sombra) y
      // se asienta girando sobre el piso de la caja.
      var ty = -cae * 30;
      var rot = giro + cae * (i % 2 ? 7 : -7);
      // Al fondo: más chica, un poco más arriba y corrida hacia su lado.
      var esc = (1 - 0.05 * dd) * (1 + cae * 0.28);
      ty += -dd * (movil ? 14 : 24);
      var tx = desv * Math.min(d, 1);
      rot += giro * 0.7 * Math.min(d, 1);
      // Ordenar: el montón se alinea y se recoge apenas bajo la franja.
      tx *= 1 - b; rot *= 1 - 0.6 * b;
      ty = ty * (1 - b) + b * -(n - 1 - i) * 2.5;
      esc = esc * (1 - b) + b * (0.97 - 0.008 * (n - 1 - i));
      var t = 'translate3d(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px,0) rotate(' + rot.toFixed(2) + 'deg) scale(' + esc.toFixed(4) + ')';
      if (t !== p.t) { p.card.style.transform = t; p.t = t; }
      var a = cae.toFixed(2);
      if (a !== p.a) { p.card.style.setProperty('--alza', a); p.a = a; }
      var op = String(Math.round(clamp(e * 4, 0, 1) * 100) / 100);
      if (op !== p.op) { p.card.style.opacity = op; p.op = op; }
      // Tono de recuerdo: menos color, un velo sepia y menos luz.
      var k = Math.min(d, 1.5) / 1.5;
      var f = d > 0.01 ? 'saturate(' + (1 - 0.35 * k).toFixed(3) + ') sepia(' + (0.22 * k).toFixed(3) + ') brightness(' + (1 - 0.06 * dd).toFixed(3) + ')' : '';
      if (f !== p.f) { p.card.style.filter = f; p.f = f; }
      // La de arriba conserva su texto (y su «Consultar por WhatsApp») bajo la franja.
      var o = String(Math.round((1 - clamp(d * 1.8, 0, 1)) * 100) / 100);
      if (o !== p.o) { p.texto.style.opacity = o; p.o = o; }
      var atras = d > 0.4 || e < 0.6;
      if (atras !== p.fondo) { p.li.classList.toggle('rec-fondo', atras); p.fondo = atras; }
    });

    // La franja cae encima de todo como una foto más: desde arriba, más
    // grande y levantada, y se asienta apenas torcida; luego entra su texto.
    var base = u - (n - 1);
    var c = clamp((base - 0.3) / 0.45, 0, 1);
    var texto = suave(clamp((base - 0.7) / 0.3, 0, 1));
    if (franja) {
      variable(franja, '--franja-cae', (1 - c * c).toFixed(4));
      // Ladeada hacia arriba a la derecha (2026-10-23, pedido del usuario).
      var ladeo = movil ? -2 : -4.5;
      variable(franja, '--franja-giro', (ladeo + (1 - c * c) * 5).toFixed(3) + 'deg');
      variable(franja, '--franja-texto', texto.toFixed(3));
    }

    // Índice: la foto de arriba y cuánto falta, hasta que entra la franja.
    if (indice) {
      var actual = clamp(Math.round(u), 0, n - 1);
      poner('indice', String(actual), function () { indiceActual.textContent = (actual < 9 ? '0' : '') + (actual + 1); });
      variable(indice, '--rec-avance', clamp(u / (n - 1), 0, 1).toFixed(3));
      variable(indice, '--rec-indice-o', (fondo * (1 - c)).toFixed(3));
    }
  }
  function programar() { if (!pendiente) pendiente = requestAnimationFrame(pintar); }

  function limpiar() {
    piezas.forEach(function (p) {
      p.card.style.transform = ''; p.card.style.filter = ''; p.card.style.opacity = ''; p.texto.style.opacity = '';
      p.card.style.removeProperty('--alza');
      p.li.classList.remove('rec-fondo'); p.t = p.f = p.o = p.a = p.op = ''; p.fondo = null;
    });
    sec.style.removeProperty('--rec-fondo'); sec.style.removeProperty('--rec-cabeza');
    if (franja) ['--franja-cae', '--franja-giro', '--franja-texto'].forEach(function (v) { franja.style.removeProperty(v); });
    if (indice) ['--rec-avance', '--rec-indice-o'].forEach(function (v) { indice.style.removeProperty(v); });
    cache = {};
  }
  function aplicar() {
    var quiere = !reducido.matches;
    if (quiere === activo) { if (activo) { medir(); programar(); } return; }
    activo = quiere;
    sec.classList.toggle('rec-on', activo);
    sec.style.setProperty('--rec-largo', String(LARGO));
    if (activo) { medir(); pintar(); } else limpiar();
  }

  addEventListener('scroll', programar, { passive: true });
  addEventListener('resize', function () { if (activo) { medir(); programar(); } });
  if (reducido.addEventListener) reducido.addEventListener('change', aplicar);
  aplicar();
})();
